'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.emptyFunc = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _common = require('../common');

var _WMCheckbox = require('../WMCheckbox');

var _WMCheckbox2 = _interopRequireDefault(_WMCheckbox);

var _WMTableHeaderCell = require('../WMTableHeaderCell');

var _WMTableHeaderCell2 = _interopRequireDefault(_WMTableHeaderCell);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	hideDisabledCheckboxes: _propTypes2.default.bool,
	children: _propTypes2.default.node.isRequired,
	onHeaderClick: _propTypes2.default.func,
	selectable: _propTypes2.default.bool,
	onSelectAllRows: _propTypes2.default.func,
	allRowsSelected: _propTypes2.default.bool
};

var WMTableHeader = function WMTableHeader(_ref) {
	var hideDisabledCheckboxes = _ref.hideDisabledCheckboxes,
	    children = _ref.children,
	    onHeaderClick = _ref.onHeaderClick,
	    selectable = _ref.selectable,
	    onSelectAllRows = _ref.onSelectAllRows,
	    allRowsSelected = _ref.allRowsSelected;
	return _react2.default.createElement(
		'div',
		{
			'data-component-identifier': 'wm-table-header',
			style: _styles2.default.header
		},
		(selectable || !hideDisabledCheckboxes) && _react2.default.createElement(
			'div',
			{
				'data-component-identifier': 'wm-table-header__checkbox-container',
				style: _styles2.default.checkbox
			},
			_react2.default.createElement(_WMCheckbox2.default, {
				disabled: !selectable,
				checked: allRowsSelected,
				onCheck: function onCheck(event, isInputChecked) {
					return onSelectAllRows(isInputChecked);
				}
			})
		),
		(0, _common.Arrayify)(children).filter(function (child) {
			return child;
		}).map(function (cell, index) {
			return _react2.default.createElement(
				_WMTableHeaderCell2.default,
				_extends({}, cell.props, {
					first: index === 0 && !selectable && hideDisabledCheckboxes,
					index: index,
					key: index,
					onHeaderClick: cell.props.onHeaderClick ? function () {
						return cell.props.onHeaderClick(index);
					} : function () {
						return onHeaderClick(index);
					}
				}),
				cell.props.children
			);
		})
	);
};

var emptyFunc = exports.emptyFunc = function emptyFunc() {};

WMTableHeader.defaultProps = {
	onHeaderClick: emptyFunc,
	onSelectAllRows: emptyFunc
};

exports.default = (0, _radium2.default)(WMTableHeader);


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableHeader/index.js